import type {BenefitProfile, BenefitProfileParams} from './entities/benefit';
import {request} from '@/services';

const BENEFIT_ENDPOINTS = {
    /** 获取权益快照（登录用户纬度 + 项目纬度） */
    AVAILABLE: 'proxy-aicomic/benefit/available',
} as const;

/** 获取权益快照 */
export const getBenefitAvailable = ({projectId}: BenefitProfileParams) =>
    request.get<BenefitProfile>(BENEFIT_ENDPOINTS.AVAILABLE, {
        params: projectId ? {projectId} : undefined,
    });
